module.exports = __webpack_public_path__ + "static/media/ExpandArrow4White.bb81d364.svg";